import { Alert, Button, Stack, Typography } from "@mui/material";
import Layout from "../Frames/Layout";
import { useState } from "react";
import Loader from "../Tools/Loader";
import { Link, useParams } from "react-router-dom";
import { useEffect } from "react";
import API from "../../services/API";
import { Add } from "@mui/icons-material";
import ProductForm from "./ProductForm";
import Product from "./Product";


export default function Products(){

    const {id} = useParams()

    const [course, setCourse] = useState(null)

    const [products, setProducts] = useState([])

    const [status, setStatus] = useState('loading')

    const [form, setForm] = useState(false)


    useEffect(() => {

        API.get(`/courses/${id}`)
            .then(r => {

                console.log(r.data)

                let course = r.data

                setCourse(course)
                
                API.get(`/products?type=${course.type?.id}&reference=${id}`)
                    .then(r => {
                        console.log(r.data)
                        setProducts(r.data)
                        setStatus('ready')
                    })
                    .catch(_ => setStatus('error'))
            })
            .catch(_ => setStatus('error'))
        
    }, [id])


    const handleDelete = id => setProducts([...products].filter(p => p.id !== id))

    const handleChange = product => {
        let copy = [...products].filter(p => p.id !== product.id)
        copy.push(product)
        setProducts(copy)
    }


    return <Layout menu='organize' tab='products'>


        <Stack spacing={4} sx={{maxWidth: 600, margin: 'auto', pt: 4, pb: 4}}>


            <Typography variant='h1'>Tarifs de l'événement</Typography>


            {status === 'loading' && <Loader />}


            {(status === 'ready' && !form) &&
            
                <Stack spacing={1}>

                    {products
                        .sort((a,b) => a.price - b.price)
                        .map(p => 
                            <Product 
                                key={p.id} 
                                data={p} 
                                onEdit={() => setForm(p)}
                                onDelete={handleDelete}
                            />
                    )}

                    <Button 
                        startIcon={<Add />}
                        onClick={() => setForm({
                            title: '',
                            price: '',
                            stock: null,
                            reference: course.id,
                            type: course.type,
                            category: course.category,
                            taxRate: 0,
                            variant: {id: 'standard'}
                        })}
                    >
                        Ajouter un tarif
                    </Button>
                
                </Stack>
            }


            {form && 
                <ProductForm
                    product={form}
                    onClose={() => setForm(false)}
                    onSuccess={handleChange}
                />
            }


            {status === 'error' &&
                <Alert severity='error'>
                    Une erreur s'est produite.
                </Alert>
            }


            {status === 'new' &&
                <Alert severity="warning">
                    Veuillez finaliser la <Link to={`/organize/${id}`}><u>création de l'événement</u> avant de continuer</Link>.
                </Alert>
            }

        </Stack>

    </Layout>
}
